<p-dialog
  [header]="header"
  [(visible)]="visible"
  (onShow)="onShow()"
  (onHide)="onHide()"
  [modal]="true"
  [maximizable]="false"
  [draggable]="false"
  [resizable]="false"
  [class]="'sm:w-11/12 md:w-96 ' + dir"
  [contentStyle]="{ overflow: 'visible' }"
>
  <div class="py-2">
    <div [id]="grapickElId" class="grapick-container w-full mb-6"></div>

    <div class="flex gap-3 items-center">
      <select
        class="shadow-sm bg-white border border-gray-300 text-gray-900 rounded-md px-3 py-2 text-sm w-1/2"
        [ngModel]="internalType"
        (ngModelChange)="onTypeChange($event)"
        [ngModelOptions]="{ standalone: true }"
      >
        <option *ngFor="let o of gradientTypeOptions" [value]="o.value">{{ o.labelKey | translate }}</option>
      </select>

      <select
        class="shadow-sm bg-white border border-gray-300 text-gray-900 rounded-md px-3 py-2 text-sm w-1/2"
        [ngModel]="internalDirection"
        (ngModelChange)="onDirectionChange($event)"
        [ngModelOptions]="{ standalone: true }"
      >
        <option *ngFor="let o of gradientDirectionOptions" [value]="o.value">{{ o.labelKey | translate }}</option>
      </select>
    </div>

    <div class="flex items-center gap-3 mt-3">
      <textarea
        class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 rounded-md px-3 py-2 text-xs font-mono flex-1 resize-none"
        [value]="gradientCssValue"
        rows="2"
        readonly
      ></textarea>
      <button
        type="button"
        class="bg-primary text-white font-semibold py-2 px-4 rounded"
        (click)="applyAndClose()"
      >
        {{ 'CARDADD.TEMPLATE.APPLY' | translate }}
      </button>
    </div>
  </div>
</p-dialog>

